<template>
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
		<defs>
			<clipPath id="clip-path-p-hunt">
				<rect
					id="Rectangle_15500"
					data-name="Rectangle 15500"
					width="20"
					height="20"
					transform="translate(429 707)"
					fill="#fff"
					stroke="#707070"
					stroke-width="1"
				/>
			</clipPath>
		</defs>
		<g id="Mask_Group_44951" data-name="Mask Group 44951" transform="translate(-429 -707)" clip-path="url(#clip-path-p-hunt)">
			<g id="Layer_1-2" transform="translate(429 707)">
				<circle id="Ellipse_930" data-name="Ellipse 930" cx="10" cy="10" r="10" fill="#fff" />
				<path
					id="Path_33044"
					data-name="Path 33044"
					d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0ZM6.67,4.99h4.58a3.75,3.75,0,1,1,0,7.5H8.75V15H6.67V5h0ZM8.75,7.07V10.4h2.5a1.67,1.67,0,1,0,0-3.34H8.75Z"
					fill="#969bae"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'ProductHuntSvg',
};
</script>
